import { DragEventHandler, useRef } from "react";
import { ChangeAlertCallbackType } from "../../../Root";

export const useDropHandle = (typeFile: Array<string>, handleFile: Function, changeAlert: ChangeAlertCallbackType) => {
    const dropZoneRef = useRef<null | HTMLDivElement>(null);

    const onSelectFile = (e) => {
        let file = e.target.files[0];
        let extension = (name) => {
            return typeFile.indexOf(name.split('.').pop()) === -1 ? true : false
        }

        if (!file) {
            changeAlert(true, "error", "Error en selección de archivo");
        } else if (extension(file.name)) {
            changeAlert(true, "error", "Error: El tipo de archivo no es permitido.");
        } else {
            handleFile(file);
        }
    };

    const handleOver: DragEventHandler<HTMLDivElement> = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (dropZoneRef.current) {
            dropZoneRef.current.style.borderColor = "#1890ff";
            dropZoneRef.current.style.borderWidth = "2px";
            dropZoneRef.current.style.backgroundColor = "rgba(119, 119, 255,0.1)";
        }
    };

    const handleLeave: DragEventHandler<HTMLDivElement> = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (dropZoneRef.current) {
            dropZoneRef.current.style.borderColor = "lightgray";
            dropZoneRef.current.style.borderWidth = "1px";
            dropZoneRef.current.style.backgroundColor = "transparent";
        }
    };

    const handleDrop: DragEventHandler<HTMLDivElement> = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
            const filesToUpload = [];
            for (let i = 0; i < event.dataTransfer.files.length; i++) {
                filesToUpload.push(event.dataTransfer.files.item(i));
            }

            if (filesToUpload.length > 0) {
                handleFile(filesToUpload[0]);
                handleLeave(event);
            }
            event.dataTransfer.clearData();
        }
    };

    const formatExtensions = (exts: string[]) => {
        if (exts.length === 1) return `.${exts[0]}`;
        const withDots = exts.map(e => `.${e}`);
        return withDots.slice(0, -1).join(" ") + " y " + withDots[withDots.length - 1];
    };

    return {
        dropZoneRef,
        handleOver,
        handleLeave,
        handleDrop,
        onSelectFile,
        formatExtensions
    };
};
